export class Todo {
    constructor(public text: string) {
    }
}



// WEBPACK FOOTER //
// D:/Projects/Yahoo/Server API/ServerAPI/AdminAngular/src/app/shared/todo/index.ts